 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTML03_DEDICATION from '@/components/xhtml/03_Dedication'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_LIST_OF_TABLES_AND_FIGURES from '@/components/xhtml/05_LIST_OF_TABLES_AND_FIGURES'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML06_ACKNOWLEDGMENTS from '@/components/xhtml/06_ACKNOWLEDGMENTS'
 import XHTML07_INTRODUCTION__OBESITY_AND_THE_NE from '@/components/xhtml/07_Introduction__Obesity_and_the_Ne'
 import XHTML08_1__THE_NEOLIBERAL_FOOD_REGIME_AN from '@/components/xhtml/08_1__The_Neoliberal_Food_Regime_an'
 import XHTML09_2__NEOREGULATION_OF_AGRICULTURAL from '@/components/xhtml/09_2__Neoregulation_of_Agricultural'
 import XHTML10_3__FOOD_AND_INEQUALITY_IN_THE_UN from '@/components/xhtml/10_3__Food_and_Inequality_in_the_Un'
 import XHTML11_4__CLASS_DIETS_IN_THE_NAFTA_REGI from '@/components/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi'
 import XHTML12_5__NAFTA__AGRICULTURE__AND_WORK from '@/components/xhtml/12_5__NAFTA__Agriculture__and_Work'
 import XHTML13_6__GLOBALIZING_THE_NEOLIBERAL_DI from '@/components/xhtml/13_6__Globalizing_the_Neoliberal_Di'
 import XHTML14_7__FOOD_SECURITY__OBESITY__AND_I from '@/components/xhtml/14_7__Food_Security__Obesity__and_I'
 import XHTML15_CONCLUSION__WHAT_IS_TO_BE_DONE from '@/components/xhtml/15_Conclusion__What_Is_to_Be_Done'
 import XHTML16_REFERENCES from '@/components/xhtml/16_REFERENCES'
 import XHTML17_INDEX from '@/components/xhtml/17_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_LIST_OF_TABLES_AND_FIGURES",
 			"name" : "xhtml/05_LIST_OF_TABLES_AND_FIGURES",
 			"component" : XHTML05_LIST_OF_TABLES_AND_FIGURES
 		},
 		{
 			"path" : "/xhtml/love_2",
 			"name" : "xhtml/love_2",
 			"component" : XHTMLLOVE_2
 		},
 		{
 			"path" : "/xhtml/06_ACKNOWLEDGMENTS",
 			"name" : "xhtml/06_ACKNOWLEDGMENTS",
 			"component" : XHTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/07_Introduction__Obesity_and_the_Ne",
 			"name" : "xhtml/07_Introduction__Obesity_and_the_Ne",
 			"component" : XHTML07_INTRODUCTION__OBESITY_AND_THE_NE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js